import { render, staticRenderFns } from "./RechargeCode.vue?vue&type=template&id=589c6520&scoped=true"
import script from "./RechargeCode.vue?vue&type=script&lang=js"
export * from "./RechargeCode.vue?vue&type=script&lang=js"
import style0 from "./RechargeCode.vue?vue&type=style&index=0&id=589c6520&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589c6520",
  null
  
)

export default component.exports